// Layout
const VerticalLayout = () => import('@/layouts/VerticalLayout')

const instructorRequests = () => import('./views/list.vue')
const instructorslist = () => import('./views/activeList.vue')

// start Routes
export default [
  {
    path: '/instructor-requests',
    name: 'instructorRequests',
    component: VerticalLayout,
    children: [{
      path: '',
      name: 'instructorRequests',
      component: instructorRequests,
      meta: { name: 'instructorRequests', userType: 'admin', permission: 'lead.list' }
    }
    ]
  },
  {
    path: '/instructors',
    name: 'instructors',
    component: VerticalLayout,
    children: [{
      path: '',
      name: 'instructors',
      component: instructorslist,
      meta: { name: 'instructors', userType: 'admin', permission: 'lead.list' }
    }
    ]
  }
]
